import React, { Component } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import PropTypes from 'prop-types';
import { translations } from '../../../sharedJs/translations';

import '../../../styles/_utilities.scss';
import '../../../styles/_grid.scss';
import './_footer.scss';

class Footer extends Component {
    constructor() {
        super();
        autoBind(this);
    }

    onLanguageChange(event) {
        this.props.changeLanguage(event.target.value);
        var link = this.props.epiDataModel.footer.languageLinks.find(e => e.name === event.target.value);
        window.location = link.url;
        document.getElementsByTagName('html')[0].setAttribute('lang', event.target.value);
    }

    getClassName() {
        return 'c_master-footer c_master-footer--natioal-parks';
    }

    getMultilineText(text) {
        const match = /\n/.exec(text);
        if (match) {
            return text.split('\n').map(i =>
                <span key={`multiLineKey_${i}`}>{i}<br /></span>);
        }
        return <span>{text}</span>;
    }

    render() {
        // TODO: Change document.location.pathname below with pageUrl
        if (!this.props.epiDataModel || !this.props.epiDataModelLoaded || !this.props.epiDataModel.footer) {
            return null;
        }

        const {
            cookieLink,
            accessibilityStatementLink,
            privacyLink,
            aboutUsLink
        } = this.props.epiDataModel.footer;

        const translate = translations(this.props.language.name);
        return (
            <footer className={this.getClassName()} key={document.location.pathname}>
                <a
                    href="#content"
                    className="skipLink skipLink--bottom"
                >{translate.App.SkipToMainContent}
                </a>
                <div className="c_master-footer__bottom-content">
                    <div className="g_container g_container--full c_master-footer__privacy-row">
                        <ul>{privacyLink &&
                                <li>
                                    <h3 className="u_visuallyhidden">{privacyLink.name}</h3>
                                    <a href={privacyLink.url}>{privacyLink.name}</a>
                                </li>
                        }
                            {cookieLink &&
                                <li>
                                    <h3 className="u_visuallyhidden">{cookieLink.name}</h3>
                                    <a href={cookieLink.url}>{cookieLink.name}</a>
                                </li>
                            }
                            {accessibilityStatementLink &&
                                <li>
                                    <h3 className="u_visuallyhidden">{accessibilityStatementLink.name}</h3>
                                    <a href={accessibilityStatementLink.url}>{accessibilityStatementLink.name}</a>
                                </li>
                            }
                            {aboutUsLink &&
                                <li>
                                    <h3 className="u_visuallyhidden">{aboutUsLink.name}</h3>
                                    <a href={aboutUsLink.url}>{aboutUsLink.name}</a>
                                </li>
                            }
                        </ul>
                    </div>
                </div>
            </footer>
        );
    }
}

Footer.propTypes = {
    changeLanguage: PropTypes.func,
    language: PropTypes.object,
    selectedLanguage: PropTypes.string,
    epiDataModel: PropTypes.object,
    epiDataModelLoaded: PropTypes.bool
};

const mapStateToProps = state => ({
    language: state.app.language,
    epiDataModel: state.app.epiDataModel,
    epiDataModelLoaded: state.app.epiDataModelLoaded
});

export default connect(mapStateToProps, {})(Footer);
